import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType, getEveryDayDateStringList } from '@/utils/date'

export const drawCompanySpendingBarChart = (chart: ECharts, data: any, filter: any) => {
  let newData = []
  for (let item of data) {
    if (item.name) {
      newData.push(item)
    }
  }
  data = newData
  chart.setOption({
    title: {
      text: `各车队消费统计(${getTitleStringByType(filter)})`
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: [
      {
        type: 'category',
        data: data.map((item: any) => {
          return item.name
        })
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        type: 'bar',
        data: data.map((item: any) => {
          return parseFloat(parseFloat(item.total).toFixed(2))
        }),
        markPoint: {
          data: [
            { type: 'max', name: '最大值' },
            { type: 'min', name: '最小值' }
          ]
        },
        markLine: {
          data: [{ type: 'average', name: '平均值' }]
        }
      }
    ]
  })
}
